/**
 * 维修工单
 */
import { REPAIRWORKORDER } from '../types';

export default {
    name: `${REPAIRWORKORDER}`,
    path: '/repairWorkOrder',
    component: () => import(/* webpackChunkName: 'repairWorkOrder' */ '@/views/workOrderMaintain/'),
    redirect: { name: `${REPAIRWORKORDER}Index` },
    meta: {
        title: '维修工单',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${REPAIRWORKORDER}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'repairWorkOrder' */ '@/views/workOrderMaintain/home/Home.vue'),
        },
        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${REPAIRWORKORDER}Create`,
            path: 'create',
            component: () => import(/* webpackChunkName: 'repairWorkOrder' */ '@/views/workOrderMaintain/add/Add.vue'),
        },
        {
            name: `${REPAIRWORKORDER}Detail`,
            path: 'detail',
            component: () => import(/* webpackChunkName: 'repairWorkOrder' */ '@/views/workOrderMaintain/detail/Detail.vue'),
        },
    ],
};
